import { booleanProperty, getEnvironmentProps, numberProperty, stringProperty } from '@nimbus/env-props';
import { isClient } from '@nx-frontend/shared/utils';

/**
 * ! When adding new env variable add its process.env key to envVariableKeys as well
 */
export const webnotesClientEnv = {
  ...getEnvironmentProps(isClient() ? window.__WCENV || {} : process.env, {
    rumEnabled: booleanProperty('RUM_ENABLED', { defaultValue: false }),
    staticAssetPrefix: stringProperty('WEBNOTES_STATIC_ASSET_PREFIX', { defaultValue: '/box/file/' }),
    boxServiceUrl: stringProperty('BOX_SERVICE_URL', { defaultValue: '/box/' }),
    purchaseAppsumoBundleUrl: stringProperty('PURCHASE_APPSUMO_BUNDLE_URL', {
      defaultValue: 'https://dev-thefusebase.com/appsumo-subscription-billing/?orgId={orgId}&plan=appsumo-yearly-2023',
    }),
    trialEnabled: booleanProperty('TRIAL_ENABLED', { defaultValue: true }),
    appVersion: stringProperty('DD_VERSION', { defaultValue: '1.0.0' }),
    billingServiceUrl: stringProperty('BILLING_SERVICE_URL', {
      defaultValue: 'http://billing-service.nimbus.test',
    }),
    bookDemoUrl: stringProperty('BOOK_DEMO_URL', { defaultValue: '' }),
    editorServerUrl: stringProperty('EDITOR_SERVER_URL', { defaultValue: 'https://text.dev-thefusebase.com' }),
    gatewayUrl: stringProperty('GATEWAY_URL', {
      defaultValue: 'https://app.dev-thefusebase.com/gwapi2',
    }),
    transcriptApiUrl: stringProperty('TRANSCRIPT_API_URL', { defaultValue: 'https://stt-api.dev-thefusebase.com' }),
    paywallBundleJsUrl: stringProperty('PAYWALL_BUNDLE_JS_URL', {
      defaultValue: 'https://nimbusweb.me/static/paywall-bundle.js',
    }),
    businessBillingUrl: stringProperty('BUSINESS_BILLING_URL', {
      defaultValue: 'https://nimbusweb.me/business-billing',
    }),
    invitesBundleJsUrl: stringProperty('INVITES_BUNDLE_JS_URL', { defaultValue: '' }),
    noteAnnotationServiceUrl: stringProperty('NOTE_ANNOTATION_SERVICE_URL', { defaultValue: '' }),
    guideGenUrl: stringProperty('GUIDE_GEN_URL', {
      defaultValue: 'https://4onpzrrz5glocqa7uy4yntayhu0yusqv.lambda-url.eu-central-1.on.aws/',
    }),
    checkFirstVisitTimestamp: numberProperty('CHECK_FIRST_VISIT_TIMESTAMP', { defaultValue: 1723680000 }),
    ddEnv: stringProperty('DD_ENV', {
      defaultValue: 'prod',
    }),
  }),
  isClientSide: isClient(),
};

export function getEnvScriptContent() {
  const envVariableKeys = [
    'RUM_ENABLED',
    'WEBNOTES_STATIC_ASSET_PREFIX',
    'PURCHASE_APPSUMO_BUNDLE_URL',
    'TRIAL_ENABLED',
    'DD_VERSION',
    'BOOK_DEMO_URL',
    'FZB_ASSISTANT_HOST',
    'FZB_ASSISTANT_HOST_CREATE_MESSAGE',
    'EDITOR_SERVER_URL',
    'GATEWAY_URL',
    'PAYWALL_BUNDLE_JS_URL',
    'SHARE_BUNDLE_JS_URL',
    'BUSINESS_BILLING_URL',
    'LOCAL_SOKECT_PROXY',
    'AI_SERVICE_API_URL',
    'INVITES_BUNDLE_JS_URL',
    'GUIDE_GEN_URL',
    'CHECK_FIRST_VISIT_TIMESTAMP',
    'DD_ENV',
  ];

  const envs: Record<string, string> = { NOTE_ANNOTATION_SERVICE_URL: '-' };

  for (const key of envVariableKeys) {
    const value = process.env[key];
    if (value != null) {
      envs[key] = value;
    }
  }

  return `(function (window) { window.__WCENV = Object.assign(window.__WCENV ?? {}, ${JSON.stringify(envs)});})(this);`;
}
